import { SeoPropertiesModel } from '../parents/seo-properties.model';

export class BrandModel extends SeoPropertiesModel {
  static ATTR_ID = 'id';
  static ATTR_NAME = 'name';
  static ATTR_DESCRIPTION = 'description';
  static ATTR_IMAGE_ID = 'image_id';
  static ATTR_SLUG = 'slug';
  static ATTR_HAS_AUTOMATIC_SLUG = 'has_automatic_slug';
  static ATTR_IS_ACTIVE = 'is_active';
  static ATTR_CREATED_AT = 'created_at';

  get name() {
    return this.attributes[BrandModel.ATTR_NAME];
  }

  get description() {
    return this.attributes[BrandModel.ATTR_NAME];
  }

  get imageId() {
    return this.attributes[BrandModel.ATTR_NAME];
  }

  get slug() {
    return this.attributes[BrandModel.ATTR_NAME];
  }

  get hasAutomaticSlug() {
    return this.attributes[BrandModel.ATTR_NAME];
  }

  get isActive() {
    return this.attributes[BrandModel.ATTR_NAME];
  }

  get createdAt() {
    return this.attributes[BrandModel.ATTR_NAME];
  }

  get createdAtFormatted() {
    return new Date(this.createdAt).toLocaleString('cs-CZ');
  }
}
